var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteButtonOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.301,
    height: 48.3,
    viewBox: "0 0 48.301 48.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ddd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9454",
    "data-name": "\\u9577\\u65B9\\u5F62 9454",
    width: 28.475,
    height: 40.592,
    transform: "translate(0 0)",
    fill: "#ff4ebb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ddd-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9455",
    "data-name": "\\u9577\\u65B9\\u5F62 9455",
    width: 36,
    height: 36,
    fill: "#ff4ebb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15463",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15463",
    transform: "translate(-17786 -4357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9456",
    "data-name": "\\u9577\\u65B9\\u5F62 9456",
    width: 48.3,
    height: 48.3,
    transform: "translate(17786 4357)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15462",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15462",
    transform: "translate(-3 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15459",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15459",
    transform: "translate(17799 4346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15458",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15458",
    "clip-ddd": "url(#clip-ddd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20979",
    "data-name": "\\u30D1\\u30B9 20979",
    d: "M20.564,36.525H16.272v-4.23a14.183,14.183,0,0,0,5.959-2.309l-2.948-2.948A10.158,10.158,0,0,1,4.068,18.216a2.034,2.034,0,1,0-4.068,0A14.237,14.237,0,0,0,12.2,32.29v4.23H7.913A1.81,1.81,0,0,0,6.1,38.33v.452a1.81,1.81,0,0,0,1.81,1.81H20.564a1.81,1.81,0,0,0,1.81-1.81v-.447a1.81,1.81,0,0,0-1.81-1.81",
    fill: "#ff4ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20980",
    "data-name": "\\u30D1\\u30B9 20980",
    d: "M26.441,16.182a2.034,2.034,0,0,0-2.034,2.034,10.124,10.124,0,0,1-2.757,6.947l2.87,2.869a14.2,14.2,0,0,0,3.955-9.816,2.034,2.034,0,0,0-2.034-2.034",
    fill: "#ff4ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20981",
    "data-name": "\\u30D1\\u30B9 20981",
    d: "M22.374,18.214V8.046a8.136,8.136,0,0,0-16.271,0V9.617L20.212,23.725a8.1,8.1,0,0,0,2.162-5.511",
    fill: "#ff4ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20982",
    "data-name": "\\u30D1\\u30B9 20982",
    d: "M14.239,26.346v0a8.1,8.1,0,0,0,3.538-.818L6.1,13.859v4.352a8.136,8.136,0,0,0,8.136,8.135",
    fill: "#ff4ebb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15461",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15461",
    transform: "translate(17797 4346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15460",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15460",
    "clip-ddd": "url(#clip-ddd-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20983",
    "data-name": "\\u30D1\\u30B9 20983",
    d: "M34.5,36a1.5,1.5,0,0,1-1.061-.439l-33-33A1.5,1.5,0,0,1,2.561.439l33,33A1.5,1.5,0,0,1,34.5,36",
    fill: "#ff4ebb"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteButtonOff);
export default __webpack_public_path__ + "static/media/muteButtonOff.94d8152fcbccd1ffe34b1a8f1ad7bea8.svg";
export { ForwardRef as ReactComponent };